import { LegacyReforestationProjectType } from "@ecologi/shared";
import { ProjectVisualsType } from "./project-visuals";
import ForestryIcon from "@ecologi/assets/icons/ProjectInsights/forestry.svg";

export const reforestationVisuals: Record<
  LegacyReforestationProjectType,
  ProjectVisualsType
> = {
  [LegacyReforestationProjectType.Reforestation]: {
    icon: <ForestryIcon />,
    pictogram: `/images/app/forest/carbon_avoidance/pictograms/forestry.svg`,
  },
  [LegacyReforestationProjectType.All]: {
    icon: <></>,
    pictogram: "",
  },
  [LegacyReforestationProjectType.None]: {
    icon: <></>,
    pictogram: "",
  },
};
